import ResidentStatusHistoryScreen from "app/screens/residents/show/ResidentStatusHistoryScreen";

export default function ResidentStatusHistoryPage() {
  return <ResidentStatusHistoryScreen />;
}
